import AppEmptyState from "@/components/ui/AppEmptyState";

const PilotageEmptyState = ({
  icon,
  title,
  description,
  actionLabel = null,
  onAction = null,
  isReadOnly = false,
  testId,
}) => (
  <AppEmptyState
    icon={icon}
    title={title}
    description={description}
    actionLabel={isReadOnly ? null : actionLabel}
    onAction={isReadOnly ? null : onAction}
    secondaryLabel={isReadOnly ? "Accès en lecture seule" : null}
    testId={testId}
  />
);

export default PilotageEmptyState;
